import React, {
    forwardRef,
    useRef,
    useImperativeHandle,
    useEffect,
    useState
} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { s_heart, r_heart } from '@fiverr-private/fit/icons';
import { Icon } from '@fiverr-private/fit';

import classes from './HeartBtn.module.scss';

export const HeartBtn = forwardRef(({
    className,
    onClick,
    filled,
    inspireVariant,
    heartIcon,
    ...rest
}, forwardedRef) => {
    const btnRef = useRef(null);
    useImperativeHandle(forwardedRef, () => btnRef.current, []);

    const [animated, setAnimated] = useState(false);
    const playAnimation = () => setAnimated(true);
    const stopAnimation = () => setAnimated(false);

    useEffect(() => {
        if (animated) {
            btnRef.current.addEventListener('animationend', stopAnimation);
        } else {
            btnRef.current.removeEventListener('animationend', stopAnimation);
        }
    }, [animated]);

    const btnOnClick = (e) => {
        playAnimation();

        if (onClick) {
            onClick(e);
        }
    };

    const btnClassName = classNames(
        classes.btn,
        {
            [classes.filled]: filled,
            [classes.animated]: animated,
            [classes.inspireVariant]: inspireVariant
        },
        className
    );

    const icon = !filled && inspireVariant ? r_heart : s_heart;

    return (
        <button ref={btnRef} className={btnClassName} onClick={btnOnClick} {...rest}>
            {heartIcon || <Icon className={classes.icon}>{icon}</Icon>}
        </button>
    );
});

HeartBtn.displayName = 'HeartBtn';

/**
 * @extends {
 * Omit<
 *  React.ButtonHTMLAttributes<HTMLButtonElement>,
 *  | 'children'
 * >
 * }
 */
HeartBtn.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    filled: PropTypes.bool,
    inspireVariant: PropTypes.bool,
    heartIcon: PropTypes.node
};

HeartBtn.defaultProps = {
    filled: false,
    inspireVariant: false
};
